var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 48,
    viewBox: "0 0 58 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9872 20.6637C19.5564 13.8898 29.9383 9.424 35.133 7.26636C49.9647 1.10586 53.0466 0.0357136 55.0553 0.00037677C55.4971 -0.00739518 56.4849 0.101946 57.1248 0.620448C57.6651 1.05826 57.8138 1.64969 57.8849 2.06478C57.9561 2.47988 58.0446 3.42548 57.9742 4.16434C57.1705 12.5976 53.6927 33.0629 51.9235 42.5083C51.1748 46.505 49.7007 47.8451 48.2736 47.9762C45.1721 48.2612 42.817 45.9294 39.8131 43.963C35.1126 40.886 32.4571 38.9706 27.8945 35.968C22.6215 32.498 26.0398 30.5908 29.0448 27.474C29.8312 26.6583 43.4963 14.246 43.7608 13.12C43.7938 12.9792 43.8245 12.4543 43.5123 12.1771C43.2 11.8999 42.7391 11.9947 42.4065 12.0701C41.935 12.177 34.4259 17.1334 19.8791 26.9393C17.7477 28.4009 15.8171 29.113 14.0873 29.0757C12.1804 29.0346 8.5123 27.999 5.78543 27.1138C2.44081 26.0281 -0.217422 25.4541 0.014051 23.6103C0.134616 22.6499 1.459 21.6677 3.9872 20.6637Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.6a590c64c9b05fe444408005a8c8a72d.svg";
export { ForwardRef as ReactComponent };